// mantine
import { Avatar, Button, Paper, Table } from '@mantine/core';
// icons
import { Plus } from 'lucide-react';
// components
import { PopoverButton } from '@newo/ui-kit';
import { IProvider } from '@newo/api/gateway';
import LLMKey from '@/pages/Profile/components/LLMKeys/components/LLMKey';
import LLMKeyForm from '@/pages/Profile/components/LLMKeys/components/LLMKeyForm';
import { EmptyState, LoadingState } from '@/components/Table';
// utils
import { useProviderKeysQuery } from '@/services/customer/providers/providers.queries.ts';

interface ProviderProps {
    provider: IProvider;
}

const Provider = ({ provider }: ProviderProps) => {
    const {
        data: llmKeys = [],
        isLoading,
        isSuccess
    } = useProviderKeysQuery(provider.id);

    const hasMainKey = llmKeys.some((llmKey) => llmKey.role === 'main');

    return (
        <Paper p="xl" shadow-sm="xs">
            <div className="flex items-center gap-4">
                <Avatar
                    radius="xl"
                    size="md"
                    src={`https://static.newo.ai/providers/${provider.idn}.png`}
                >
                    {provider.title[0]}
                </Avatar>
                {provider.title}
                <PopoverButton
                    className="ml-auto"
                    trigger={
                        <Button
                            component="div"
                            leftSection={<Plus />}
                            variant="transparent"
                        >
                            Add Key
                        </Button>
                    }
                >
                    {(close) => (
                        <LLMKeyForm
                            hasMainKey={hasMainKey}
                            providerId={provider.id}
                            onClose={close}
                        />
                    )}
                </PopoverButton>
            </div>
            <p className="text-sm text-gray-6">{provider.description}</p>
            <Table>
                <Table.Thead>
                    <Table.Tr>
                        <Table.Th w="50%">Key</Table.Th>
                        <Table.Th>Role</Table.Th>
                        <Table.Th>Priority</Table.Th>
                        <Table.Th />
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody>
                    {isLoading ? <LoadingState /> : undefined}
                    {isSuccess && llmKeys.length === 0 ? (
                        <EmptyState />
                    ) : undefined}
                    {llmKeys.map((llmKey) => (
                        <LLMKey
                            hasMainKey={hasMainKey}
                            key={llmKey.id}
                            llmKey={llmKey}
                        />
                    ))}
                </Table.Tbody>
            </Table>
        </Paper>
    );
};

export default Provider;
